import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '数据概览' }
      },
      {
        path: 'settlement',
        name: 'Settlement',
        component: () => import('@/views/Settlement.vue'),
        meta: { title: '入驻管理' }
      },
      {
        path: 'scenic',
        name: 'ScenicManagement',
        component: () => import('@/views/ScenicManagement.vue'),
        meta: { title: '景区管理' }
      },
      {
        path: 'withdrawal',
        name: 'Withdrawal',
        component: () => import('@/views/Withdrawal.vue'),
        meta: { title: '提现管理' }
      },
      {
        path: 'merchant',
        name: 'Merchant',
        component: () => import('@/views/Merchant.vue'),
        meta: { title: '商家管理' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/User.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'order',
        name: 'Order',
        component: () => import('@/views/Order.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'order/:id',
        name: 'OrderDetail',
        component: () => import('@/views/OrderDetail.vue'),
        meta: { title: '订单详情' }
      },
      {
        path: 'merchant/:id',
        name: 'MerchantDetail',
        component: () => import('@/views/MerchantDetail.vue'),
        meta: { title: '商家详情' }
      },
      {
        path: 'boat/type',
        name: 'BoatType',
        component: () => import('@/views/BoatType.vue'),
        meta: { title: '船只类型' }
      },
      {
        path: 'boat/list',
        name: 'BoatList',
        component: () => import('@/views/BoatList.vue'),
        meta: { title: '船只列表' }
      },
      {
        path: 'coupon',
        name: 'Coupon',
        component: () => import('@/views/Coupon.vue'),
        meta: { title: '优惠券管理' }
      },
      {
        path: 'notification',
        name: 'Notification',
        component: () => import('@/views/Notification.vue'),
        meta: { title: '消息管理' }
      },
      {
        path: 'permission',
        name: 'Permission',
        component: () => import('@/views/Permission.vue'),
        meta: { title: '系统权限' }
      },
      {
        path: 'system/config',
        name: 'SystemConfig',
        component: () => import('@/views/SystemConfig.vue'),
        meta: { title: '系统配置' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.meta.public) {
    if (token && to.path === '/login') {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
